// cspell:words turnc
import type { Meta, StoryFn } from '@storybook/react';
import type { MouseEvent } from 'react';
import { action } from '@storybook/addon-actions';

import { Avatar, Button, EmailDisplay, PhoneDisplay, useElement } from '@pega/cosmos-react-core';
import type { FieldValueListProps } from '@pega/cosmos-react-core';
import { Glimpse } from '@pega/cosmos-react-work';

export default {
  title: 'Work/Glimpse',
  component: Glimpse,
  parameters: { layout: 'centered' }
} as Meta;

export const GlimpseDemo: StoryFn = () => {
  const [target, setTarget] = useElement<HTMLButtonElement>(null);
  const fields: FieldValueListProps['fields'] = [
    {
      name: 'Project',
      value: 'Constellation Demo'
    },
    {
      name: 'Phone number',
      value: <PhoneDisplay value='(111) 111-1111' />
    },
    {
      name: 'Email',
      value: <EmailDisplay value='turnc@example.com' />
    },
    {
      name: 'Reports to',
      value: 'Helen Bush'
    }
  ];

  return (
    <>
      <Button
        variant='link'
        onClick={(e: MouseEvent<HTMLButtonElement>) => {
          setTarget(e.currentTarget);
        }}
      >
        Open Glimpse
      </Button>
      {target && (
        <Glimpse
          id='turnc'
          target={target}
          heading={{
            primary: 'Cindy Turner',
            secondary: 'Lead Engineer',
            visual: <Avatar name='Cindy Turner' />
          }}
          fields={fields}
          onViewProfile={action('View profile')}
          onDismiss={() => setTarget(null)}
        />
      )}
    </>
  );
};
